import { render, staticRenderFns } from "./Nominations.vue?vue&type=template&id=00112184&scoped=true"
import script from "./Nominations.vue?vue&type=script&lang=js"
export * from "./Nominations.vue?vue&type=script&lang=js"
import style0 from "./Nominations.vue?vue&type=style&index=0&id=00112184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00112184",
  null
  
)

export default component.exports